
  import Raven from 'raven-js';
  import Vue from 'vue';
  import RavenVue from 'raven-js/plugins/vue';

  Raven.config("https://a8332305e787746b822b9a8842cec5f0@o123744.ingest.us.sentry.io/4511110332219392",
      {
        ignoreUrls: [
          // Facebook flakiness
          /graph\.facebook\.com/i,
          // iubenda
          /cdn\.iubenda\.com/i,
          // Facebook blocked
          /connect\.facebook\.net\/en_US\/all\.js/i,
          // Chrome extensions
          /extensions\//i,
          /^chrome:\/\//i,
        ]
      })
      .addPlugin(RavenVue, Vue)
      .install();

  Raven.setTagsContext({ environment: "staging" });
  Raven.setTagsContext({ platform: 'frontend' });
  Raven.setTagsContext({ app: 'adcontrol' });




// WEBPACK FOOTER //
// app/javascript/shared/errors.js.erb